import { useEffect, useState } from 'react'
import IAClient from 'components/Processes/ProcessActions/IAClient'
import { getAiStatus } from 'services/ai'

// Botão flutuante da Sofia em todas as telas, só quando a IA está ligada
export default function Sofia() {
  const [ativa, setAtiva] = useState(false)
  useEffect(() => { getAiStatus().then((s) => setAtiva(Boolean(s?.ativa))) }, [])
  return ativa ? <IAClient /> : null
}
